<deletemodal id="customer-tabs" [deleteModal]="attachmentWarning"></deletemodal>
<deletemodal id="customer-tabs" [deleteModal]="clearFormAlert"></deletemodal>
<section class="">
  <div *ngIf="ticketCreateForm" class="w-75">
    <form [formGroup]="ticketCreateForm" (ngSubmit)="createTicket()" id="Create-Ticket-js">

      <div class="form-horizontal">
        <div class="col-xs-12 col-md-6 left-padding-0">
          <!-- Operating Country -->
          <div class="">
            <label for="operatingCountry"
              class="control-label col-xs-5">{{'ticketing-system.Assigned to Country' |translate | translateKey}}</label>
            <div class="col-xs-7  floating-input">
              <select autofocus tabindex="0" formControlName="operatingCountry" class="form-control"
                (change)="operatingCountryChange($event.target.value, true)">
                <option *ngFor="let country of countries | orderBy:'name'" [value]="country.id">{{country.name}}
                </option>
              </select>
              <div class="alert-msg"
                *ngIf="!ticketCreateForm.controls['operatingCountry'].valid && ticketCreateForm.controls['operatingCountry'].hasError('required') &&(ticketCreateForm.controls['operatingCountry'].touched|| isSubmitted)">
                {{'validation-message.Required'|translate | translateKey}}
              </div>
            </div>
          </div>
          <!-- Country -->
          <div class="">
            <label for="country"
              class="control-label col-xs-5">{{'ticketing-system.Country'|translate | translateKey}}</label>
            <div class="col-xs-7 floating-input">
              <select tabindex="0" formControlName="country" class="form-control"
                (change)="getCountryIsoCodeThree($event.target.value, true)">
                <option value="" [selected]="true">--{{'ticketing-system.Select' |translate | translateKey}}--</option>
                <option *ngFor="let country of allCountries | orderBy:'name'" [value]="country.countryCode">
                  {{country.countryName}}</option>
              </select>
              <div class="alert-msg"
                *ngIf="!ticketCreateForm.controls['country'].valid && ticketCreateForm.controls['country'].hasError('required') &&(ticketCreateForm.controls['country'].touched|| isSubmitted)">
                {{'validation-message.Required'|translate | translateKey}}
              </div>
            </div>
          </div>
          <!-- Source Name -->
          <div class="">
            <label for="source"
              class="control-label col-xs-5">{{'ticketing-system.Source' |translate | translateKey}}</label>
            <div class="col-xs-7 floating-input ">
              <select tabindex="0" formControlName="source" class="form-control" (change)="onChangeOfSource()">
                <option value="" [selected]="true">--{{'ticketing-system.Select' |translate | translateKey}}--</option>
                <option *ngFor="let sourceType of sourceTypes" [ngValue]="sourceType.id">{{sourceType.value}}</option>
              </select>
              <div class="alert-msg"
                *ngIf="!ticketCreateForm.controls['source'].valid && ticketCreateForm.controls['source'].hasError('required') &&(ticketCreateForm.controls['source'].touched|| isSubmitted)">
                {{'validation-message.Required'|translate | translateKey}}
              </div>
            </div>
          </div>
          <!--  Caller Name -->
          <div class="">
            <label *ngIf="ticketCreateForm.controls['source'].value === sourceTypesEnum.Phone" for="callerName"
              class="control-label col-xs-5">{{'ticketing-system.Caller Name' |translate | translateKey}}</label>
            <label *ngIf="ticketCreateForm.controls['source'].value === sourceTypesEnum.Email || ticketCreateForm.controls['source'].value === sourceTypesEnum.Online_Form" for="callerName"
              class="control-label col-xs-5">Sender Name</label>
            <div *ngIf="ticketCreateForm.controls['source'].value === sourceTypesEnum.Phone"
              class="col-xs-7 floating-input floatLabelContainer">
              <input autofocus float-label tabindex="0" formControlName="callerName" class="form-control"
                placeholder="{{'ticketing-system.Caller Name' |translate | translateKey}}" tabindex="0" type="text">
              <div class="alert-msg"
                *ngIf="!ticketCreateForm.controls['callerName'].valid && ticketCreateForm.controls['callerName'].hasError('required') &&(ticketCreateForm.controls['callerName'].touched|| isSubmitted)">
                {{'validation-message.Required'|translate | translateKey}}
              </div>
            </div>
            <div *ngIf="ticketCreateForm.controls['source'].value === sourceTypesEnum.Email || ticketCreateForm.controls['source'].value === sourceTypesEnum.Online_Form"
              class="col-xs-7 floating-input floatLabelContainer">
              <input autofocus float-label tabindex="0" formControlName="callerName" class="form-control"
                placeholder="Sender Name" tabindex="0" type="text">
              <div class="alert-msg"
                *ngIf="!ticketCreateForm.controls['callerName'].valid && ticketCreateForm.controls['callerName'].hasError('required') &&(ticketCreateForm.controls['callerName'].touched|| isSubmitted)">
                {{'validation-message.Required'|translate | translateKey}}
              </div>
            </div>
          </div>
          <!-- Mobile Number -->
          <div class="">
            <label *ngIf="ticketCreateForm.controls['source'].value === sourceTypesEnum.Phone"
              for="sourceIdentifierValue"
              class="control-label col-xs-5">{{'ticketing-system.Phone Number' |translate | translateKey}}</label>
            <label *ngIf="ticketCreateForm.controls['source'].value === sourceTypesEnum.Email || ticketCreateForm.controls['source'].value === sourceTypesEnum.Online_Form"
              for="sourceIdentifierValue"
              class="control-label col-xs-5">{{'customer-service.Email' |translate | translateKey}}</label>
            <div *ngIf="ticketCreateForm.controls['source'].value === sourceTypesEnum.Phone"
              class="col-xs-7 floating-input floatLabelContainer">
              <input float-label tabindex="0" [mask]="phoneNumberFormat" formControlName="sourceIdentifierValue"
                class="form-control" placeholder="{{'ticketing-system.Caller Phone Number' |translate | translateKey}}"
                tabindex="0" type="text">
              <div class="alert-msg"
                *ngIf="!ticketCreateForm.controls['sourceIdentifierValue'].valid && ticketCreateForm.controls['sourceIdentifierValue'].hasError('required') &&(ticketCreateForm.controls['sourceIdentifierValue'].touched|| isSubmitted)">
                {{'validation-message.Required'|translate | translateKey}}
              </div>
              <div class="alert-msg"
                *ngIf="!ticketCreateForm.controls['sourceIdentifierValue'].valid && ticketCreateForm.controls['sourceIdentifierValue'].hasError('phoneNumberValidation') && !ticketCreateForm.controls['sourceIdentifierValue'].hasError('required') &&(ticketCreateForm.controls['sourceIdentifierValue'].touched|| isSubmitted)">
                {{'validation-message.Enter valid Phone Number'|translate | translateKey}}
              </div>
              <div class="alert-msg"
                *ngIf="!ticketCreateForm.controls['sourceIdentifierValue'].valid && ticketCreateForm.controls['sourceIdentifierValue'].hasError('phoneNumberLengthValidation') && !ticketCreateForm.controls['sourceIdentifierValue'].hasError('required') &&(ticketCreateForm.controls['sourceIdentifierValue'].touched|| isSubmitted)">
                {{'validation-message.Minimum Length should be 10 characters'|translate | translateKey}}
              </div>
            </div>
            <div *ngIf="ticketCreateForm.controls['source'].value === sourceTypesEnum.Email || ticketCreateForm.controls['source'].value === sourceTypesEnum.Online_Form"
              class="col-xs-7 floating-input floatLabelContainer">
              <input float-label tabindex="0" mask="" formControlName="sourceIdentifierValue" class="form-control"
                placeholder="Sender Email" tabindex="0" type="text">
              <div class="alert-msg"
                *ngIf="!ticketCreateForm.controls['sourceIdentifierValue'].valid && ticketCreateForm.controls['sourceIdentifierValue'].hasError('required') &&(ticketCreateForm.controls['sourceIdentifierValue'].touched|| isSubmitted)">
                {{'validation-message.Required'|translate | translateKey}}
              </div>
              <div class="alert-msg"
                *ngIf="!ticketCreateForm.controls['sourceIdentifierValue'].valid && ticketCreateForm.controls['sourceIdentifierValue'].hasError('emailValidationRule') && !ticketCreateForm.controls['sourceIdentifierValue'].hasError('required') &&(ticketCreateForm.controls['sourceIdentifierValue'].touched|| isSubmitted)">
                {{'validation-message.Enter valid Email'|translate | translateKey}}
              </div>
            </div>

          </div>
          <!-- Ticket Type -->
          <div class="">
            <label for="ticketType"
              class="control-label col-xs-5">{{'ticketing-system.Ticket Type' |translate | translateKey}}</label>
            <div class="col-xs-7 floating-input">
              <select tabindex="0" formControlName="ticketType" (change)="getSubTypes($event.target.value)"
                class="form-control">
                <option value="" [selected]="true">--{{'ticketing-system.Select' |translate | translateKey}}--</option>
                <option *ngFor="let ticketType of ticketTypes | orderBy : 'sortValue'" [value]="ticketType.id">
                  {{ticketType.value}}</option>
              </select>
              <div class="alert-msg"
                *ngIf="!ticketCreateForm.controls['ticketType'].valid && ticketCreateForm.controls['ticketType'].hasError('required') &&(ticketCreateForm.controls['ticketType'].touched|| isSubmitted)">
                {{'validation-message.Required'|translate | translateKey}}
              </div>
            </div>
          </div>

          <!-- Order ID -->
          <div class="">
            <label for="orderId"
              class="control-label col-xs-5">{{'ticketing-system.Web Order Number' |translate | translateKey}}/{{'ticketing-system.System Order Number'|translate | translateKey}}</label>
            <div class="col-xs-7 floating-input floatLabelContainer">
              <input float-label tabindex="0" formControlName="orderId" class="form-control"
                [ngClass]="{'order-border-color': inValidOrderNumber}"
                placeholder="{{'ticketing-system.Web Order Number' |translate | translateKey}}"
                tabindex="0" type="text" (blur)="getRecentOrderInformation()"  (focus)= "onFocusOrderId()">
              
              <div class="alert-msg"
                *ngIf="!ticketCreateForm.controls['orderId'].valid && ticketCreateForm.controls['orderId'].hasError('numericValidation') &&(ticketCreateForm.controls['orderId'].touched|| isSubmitted)">
                {{'validation-message.Enter valid Order ID'|translate}}
              </div>
              <div *ngIf="inValidOrderNumber && ticketCreateForm.controls['orderId'].value"
                class="alert-msg">
                <div>{{'ticketing-system.Invalid Order Number'|translate | translateKey}}</div>
              </div>

            </div>
          </div>
        </div>
        <!-- /1st Column End -->

        <!-- 2nd Column Starts -->
        <div class="col-xs-12 col-md-6">
          <!-- Sub Type -->
          <div class="">
            <label for="subType"
              class="control-label col-xs-5">{{'ticketing-system.SubType' |translate | translateKey}}</label>
            <div class="col-xs-7 floating-input">
              <select tabindex="0" formControlName="subType" class="form-control">
                <option value="" [selected]="true">--{{'ticketing-system.Select' |translate | translateKey}}--</option>
                <option *ngFor="let subType of subTypes | orderBy : 'name'" [value]="subType.id">{{subType.name}}
                </option>
              </select>
              <div class="alert-msg"
                *ngIf="!ticketCreateForm.controls['subType'].valid && ticketCreateForm.controls['subType'].hasError('required') &&(ticketCreateForm.controls['subType'].touched|| isSubmitted)">
                {{'validation-message.Required'|translate | translateKey}}
              </div>
            </div>
          </div>
          <!-- Department Name -->
          <div class="">
            <label for="department"
              class="control-label col-xs-5">{{'ticketing-system.Assign to Department' |translate | translateKey}}</label>
            <div class="col-xs-7 floating-input">
              <select tabindex="0" formControlName="department"
                (change)="getAssignedUsersByDepartments($event.target.value)" class="form-control">
                <option value="" [selected]="true">--{{'ticketing-system.Select' |translate | translateKey}}--</option>
                <option *ngFor="let department of departments" [value]="department.id">{{department.value}}</option>
              </select>
              <div class="alert-msg"
                *ngIf="!ticketCreateForm.controls['department'].valid && ticketCreateForm.controls['department'].hasError('required') &&(ticketCreateForm.controls['department'].touched|| isSubmitted)">
                {{'validation-message.Required'|translate | translateKey}}
              </div>
            </div>
          </div>
          <!-- Assigned To -->
          <div class="">
            <label for="assignTo"
              class="control-label col-xs-5">{{'ticketing-system.Assign to User' |translate | translateKey}}</label>
            <div class="col-xs-7 floating-input">
              <select tabindex="0" formControlName="assignTo" class="form-control"
                [attr.disabled]="isTicketAssign ? null:''" (change)="assignToChange()">
                <option value="" [selected]="true">--{{'ticketing-system.Select' |translate | translateKey}}--</option>
                <option *ngFor="let user of users" [value]="user.id">{{user.name}}</option>
              </select>
            </div>
          </div>
          <!-- Due Date -->
          <div class="">
            <label for="dueDate"
              class="control-label col-xs-5">{{'ticketing-system.Due Date' | translate | translateKey}}</label>
            <div class="col-xs-7 floating-input  floatLabelContainer">
              <input #dueDate [owlDateTime]="dt3" class="form-control"
                placeholder="{{'customer-service.Due Date dd-mmm-yyyy'|translate | translateKey}}"
                formControlName="dueDate" tabindex="0" appRestrictSpecialCharacters maxlength="11" float-label
                DateFormat (blur)="workTicketTransformDate(ticketCreateForm.controls['dueDate'].value)">
              <owl-date-time [pickerType]="'calendar'" panelClass="'calendar-panel'" #dt3></owl-date-time>
              <span class="ewrwer" *ngIf="showDatePicker" [owlDateTimeTrigger]="dt3">
                <span class="fa fa-calendar calendar-icon select-pointer"></span>
              </span>
              <div class="alert-msg"
                *ngIf="!ticketCreateForm.controls['dueDate'].valid && ticketCreateForm.controls['dueDate'].hasError('dateValidation') && dueDate.value.length > 1">
                {{'validation-message.Enter valid Date'|translate | translateKey}}

              </div>
              <div class="alert-msg"
                *ngIf="!ticketCreateForm.controls['dueDate'].valid && ticketCreateForm.controls['dueDate'].hasError('lessThanCurrentDate')">
                {{'validation-message.Should be greater than current Date'|translate | translateKey}}
              </div>
            </div>
          </div>
          <!-- Priority -->
          <div class="">
            <label for="priority"
              class="control-label col-xs-5">{{'ticketing-system.Priority' |translate | translateKey}}</label>
            <div class="col-xs-7 floating-input">
              <select tabindex="0" formControlName="priority" class="form-control">
                <option value="" [selected]="true">--{{'ticketing-system.Select' |translate | translateKey}}--</option>
                <option *ngFor="let ticketPriority of ticketPriorities" [ngValue]="ticketPriority.id">
                  {{ticketPriority.value}}</option>
              </select>
              <div class="alert-msg"
                *ngIf="!ticketCreateForm.controls['priority'].valid && ticketCreateForm.controls['priority'].hasError('required') &&(ticketCreateForm.controls['priority'].touched|| isSubmitted)">
                {{'validation-message.Required'|translate | translateKey}}
              </div>
            </div>
          </div>
          <!-- Location type -->
          <div class="">
            <label for="locationType"
              class="control-label col-xs-5">{{'ticketing-system.Location Type' |translate | translateKey}}</label>
            <div class="col-xs-7 floating-input">
              <select tabindex="0" formControlName="locationType" class="form-control"
                [attr.disabled]="enableLocationType?null:''">
                <option value="" [selected]="true">--{{'ticketing-system.Select' |translate | translateKey}}--</option>
                <option *ngFor="let locationType of locationTypes | orderBy : 'value'" [value]="locationType.id">
                  {{locationType.value}}</option>
              </select>
              <div class="alert-msg"
                *ngIf="!ticketCreateForm.controls['locationType'].valid && ticketCreateForm.controls['locationType'].hasError('required') &&(ticketCreateForm.controls['locationType'].touched|| isSubmitted)">
                {{'validation-message.Required'|translate | translateKey}}
              </div>
            </div>
          </div>
          <!-- Status -->
          <div class="">
            <label for="status"
              class="control-label col-xs-5">{{'ticketing-system.Status'|translate | translateKey}}</label>
            <div class="col-xs-7 floating-input">
              <select tabindex="0" formControlName="status" class="form-control">
                <!-- <option value="">--{{'ticketing-system.Select'|translate | translateKey}}--</option> -->
                <option *ngFor="let status of ticketStatus" [value]="status.id">{{status.value}}</option>
              </select>
              <div class="alert-msg"
                *ngIf="!ticketCreateForm.controls['status'].valid && ticketCreateForm.controls['status'].hasError('required') &&(ticketCreateForm.controls['status'].touched|| isSubmitted)">
                {{'validation-message.Required'|translate}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row clearfix">&nbsp;</div>

      <div class="row">
        <!-- <div class="col-md-4 floating-input floatLabelContainer">
                    <select tabindex="0" formControlName="operatingCountry" class="form-control" (change)="operatingCountryChange($event.target.value)">
                        <option *ngFor="let country of countries" [value]="country.id">{{country.name}}</option>
                    </select>
                    <div class="alert-msg" *ngIf="!ticketCreateForm.controls['operatingCountry'].valid && ticketCreateForm.controls['operatingCountry'].hasError('required') &&(ticketCreateForm.controls['operatingCountry'].touched|| isSubmitted)">
                        {{'validation-message.Required'|translate | translateKey | translateKey}}
                    </div>
                </div>

                <div class="col-md-4 floating-input floatLabelContainer">
                    <input autofocus float-label tabindex="0" formControlName="callerName" class="form-control" placeholder="{{'ticketing-system.Caller Name' |translate | translateKey | translateKey}}" tabindex="0"
                        type="text">
                    <div class="alert-msg" *ngIf="!ticketCreateForm.controls['callerName'].valid && ticketCreateForm.controls['callerName'].hasError('required') &&(ticketCreateForm.controls['callerName'].touched|| isSubmitted)">
                        {{'validation-message.Required'|translate | translateKey | translateKey}}
                    </div>
                </div>

                <div class="col-md-4 floating-input floatLabelContainer">
                    <select tabindex="0" formControlName="source" class="form-control" (change)="onChangeOfCountry()">
                        <option value="" [selected]="true">--{{'ticketing-system.Select' |translate | translateKey | translateKey}}--</option>
                        <option *ngFor="let sourceType of sourceTypes" [ngValue]="sourceType.id">{{sourceType.value}}</option>
                    </select>
                    <div class="alert-msg" *ngIf="!ticketCreateForm.controls['source'].valid && ticketCreateForm.controls['source'].hasError('required') &&(ticketCreateForm.controls['source'].touched|| isSubmitted)">
                        {{'validation-message.Required'|translate | translateKey | translateKey}}
                    </div>
                </div>
                <div class="col-md-4 floating-input floatLabelContainer">
                    <input autofocus float-label tabindex="0" formControlName="callerPhoneNumber" class="form-control" placeholder="{{'ticketing-system.Mobile Phone Number' |translate | translateKey | translateKey}}"
                        tabindex="0" type="text">
                    <div class="alert-msg" *ngIf="!ticketCreateForm.controls['callerPhoneNumber'].valid && ticketCreateForm.controls['callerPhoneNumber'].hasError('required') &&(ticketCreateForm.controls['callerPhoneNumber'].touched|| isSubmitted)">
                        {{'validation-message.Required'|translate | translateKey | translateKey}}
                    </div>
                </div>
                <div class="col-md-4 floating-input floatLabelContainer">
                    <select tabindex="1" formControlName="ticketType" (change)="getSubTypes($event.target.value)" class="form-control">
                        <option value="" [selected]="true">--{{'ticketing-system.Select' |translate | translateKey | translateKey}}--</option>
                        <option *ngFor="let ticketType of ticketTypes" [value]="ticketType.id">{{ticketType.value}}</option>
                    </select>
                    <div class="alert-msg" *ngIf="!ticketCreateForm.controls['ticketType'].valid && ticketCreateForm.controls['ticketType'].hasError('required') &&(ticketCreateForm.controls['ticketType'].touched|| isSubmitted)">
                        {{'validation-message.Required'|translate | translateKey | translateKey}}
                    </div>
                </div>
                <div class="col-md-4 floating-input floatLabelContainer">
                    <select tabindex="1" formControlName="subType" class="form-control" (change)="subTypeChange($event.target.value)">
                        <option value="" [selected]="true">--{{'ticketing-system.Select' |translate | translateKey | translateKey}}--</option>
                        <option *ngFor="let subType of subTypes | orderBy : 'name'" [value]="subType.id">{{subType.name}}</option>
                    </select>
                    <div class="alert-msg" *ngIf="!ticketCreateForm.controls['subType'].valid && ticketCreateForm.controls['subType'].hasError('required') &&(ticketCreateForm.controls['subType'].touched|| isSubmitted)">
                        {{'validation-message.Required'|translate | translateKey | translateKey}}
                    </div>
                </div>
                <div class="col-md-4 floating-input floatLabelContainer">
                    <select tabindex="1" formControlName="department" (change)="getAssignedUsersByDepartments($event.target.value)" class="form-control">
                        <option value="" [selected]="true">--{{'ticketing-system.Select' |translate | translateKey | translateKey}}--</option>
                        <option *ngFor="let department of departments" [value]="department.id">{{department.value}}</option>
                    </select>
                    <div class="alert-msg" *ngIf="!ticketCreateForm.controls['department'].valid && ticketCreateForm.controls['department'].hasError('required') &&(ticketCreateForm.controls['department'].touched|| isSubmitted)">
                        {{'validation-message.Required'|translate | translateKey | translateKey}}
                    </div>
                </div>

                <div class="col-md-4 floating-input floatLabelContainer">
                    <select tabindex="1" formControlName="assignTo" class="form-control not-required" disabled="{{!isTicketAssign}}">
                        <option value="" [selected]="true">--{{'ticketing-system.Select' |translate | translateKey | translateKey}}--</option>
                        <option *ngFor="let user of users" [value]="user.id">{{user.name}}</option>
                    </select>
                    <div class="alert-msg" *ngIf="!ticketCreateForm.controls['assignTo'].valid && ticketCreateForm.controls['assignTo'].hasError('required') &&(ticketCreateForm.controls['assignTo'].touched|| isSubmitted)">
                        {{'validation-message.Required'|translate | translateKey | translateKey}}
                    </div>
                </div>
                <div class="col-md-4 floating-input floatLabelContainer">
                    <input type="text" float-label tabindex="0" class="form-control" [dropSpecialCharacters]="false" mask="00/00/0000" formControlName="dueDate"
                        placeholder="{{'customer-service.Due Date mm/dd/yyyy' |translate | translateKey | translateKey}}" />
                    <div class="alert-msg" *ngIf="!ticketCreateForm.controls['dueDate'].valid && ticketCreateForm.controls['dueDate'].hasError('required') &&(ticketCreateForm.controls['dueDate'].touched|| isSubmitted)">
                        {{'validation-message.Required'|translate | translateKey | translateKey}}
                    </div>
                    <div class="alert-msg" *ngIf="!ticketCreateForm.controls['dueDate'].valid && ticketCreateForm.controls['dueDate'].hasError('dateValidation')">
                        {{'validation-message.Enter valid Date'|translate | translateKey | translateKey}}
                    </div>
                </div>
                <div class="col-md-4 floating-input floatLabelContainer">
                    <select tabindex="1" formControlName="priority" class="form-control">
                        <option value="" [selected]="true">--{{'ticketing-system.Select' |translate | translateKey | translateKey}}--</option>
                        <option *ngFor="let ticketPriority of ticketPriorities" [ngValue]="ticketPriority.id">{{ticketPriority.value}}</option>
                    </select>
                    <div class="alert-msg" *ngIf="!ticketCreateForm.controls['priority'].valid && ticketCreateForm.controls['priority'].hasError('required') &&(ticketCreateForm.controls['priority'].touched|| isSubmitted)">
                        {{'validation-message.Required'|translate | translateKey | translateKey}}
                    </div>
                </div> -->

        <!--Copy To-->

        <div class="col-md-12 pr-42 copy_to__block">
          <tag-input name="copyTo" [formControlName]="'copyTo'" [onlyFromAutocomplete]="true" [allowDupes]="false"
            [editable]='true' [separatorKeyCodes]="[188,186,13]" [placeholder]="'Copy To'"
            [secondaryPlaceholder]="'Copy To'" [displayBy]="'displayName'" [identifyBy]="'displayName'"
            [addOnPaste]="false" [addOnBlur]="true" [pasteSplitPattern]="splitPattern" theme='bootstrap'>
            <tag-input-dropdown [autocompleteObservable]='requestAutocompleteItems' [appendToBody]="false"
              [dynamicUpdate]="false" [identifyBy]="'displayName'">
              <ng-template let-item="item" let-index="index">
                {{item.firstName}} {{item.lastName}} ({{item.username}})
              </ng-template>
            </tag-input-dropdown>
          </tag-input>

        </div>

        <div class="col-md-12 floating-input floatLabelContainer pr-42">
          <input float-label tabindex="0" type="text" formControlName="subject" class="form-control"
            placeholder="{{'ticketing-system.Subject' |translate | translateKey}}">
          <div class="alert-msg"
            *ngIf="!ticketCreateForm.controls['subject'].valid && ticketCreateForm.controls['subject'].hasError('required') &&(ticketCreateForm.controls['subject'].touched|| isSubmitted)">
            <div *ngIf="ticketCreateForm.controls['subject'].errors.required">
              {{'validation-message.Required'|translate | translateKey}}
            </div>
          </div>
          <div class="alert-msg"
            *ngIf="!ticketCreateForm.controls['subject'].valid && ticketCreateForm.controls['subject'].hasError('maxlength') &&  (ticketCreateForm.controls['subject'].touched || isSubmitted)">
            {{'validation-message.Maximum length should be ||maxLength|| characters.' |translate| translateKey:subjectMaxLength}}
          </div>
        </div>
        <div class="col-md-12 floating-input floatLabelContainer editor-block pr-42 textarea-msg">
          <textarea float-label tabindex="0" class="form-control overflow-x-hidden" formControlName="description"
            id="Description" placeholder="{{'ticketing-system.Description'|translate | translateKey}}"
            rows="5"></textarea>
          <div class="alert-msg"
            *ngIf="!ticketCreateForm.controls['description'].valid && ticketCreateForm.controls['description'].hasError('required') &&(ticketCreateForm.controls['description'].touched|| isSubmitted)">
            <div *ngIf="ticketCreateForm.controls['description'].errors.required">
              {{'validation-message.Required'|translate | translateKey}}
            </div>
          </div>
        </div>
        <div class="row-sameheight-block">
          <div *ngIf="([FBOManageTicketPermissions[2]] | hasAccess : customerServiceAccessLevelId)"
            class="col-xs-12 col-md-5 pad-top-10 column-equal">
            <div class="table-section">
              <div class="table-responsive">
                <table class="table table-striped custab">
                  <thead>
                    <tr>
                      <th>{{'ticketing-system.File Name' |translate | translateKey}}&nbsp;</th>
                      <th>{{'ticketing-system.Actions' |translate | translateKey}}&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody *ngIf="uploader?.queue?.length">
                    <tr *ngFor="let item of uploader.queue">
                      <td style="width:80%">{{ item?.file?.name }}</td>
                      <td class="options">
                        <i class="line-height1-2 fa fa-trash"
                          (click)="item.remove();attachmentsLength= attachmentsLength-1;"
                          title="{{'ticketing-system.Delete'|translate | translateKey}}">
                        </i>
                      </td>
                    </tr>
                  </tbody>
                  <tbody>
                    <tr>
                      <td colspan="2" class="text-align-center">
                        {{'ticketing-system.Max 5 attachments allowed' |translate | translateKey}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-7 pad-top-10 column-equal">
            <label
              *ngIf="([FBOManageTicketPermissions[2]] | hasAccess : customerServiceAccessLevelId) && !(attachmentsLength>= 5)"
              tabindex="0" (keyup.enter)="fileSelect.click()" for="attachFile"
              class="mar-left10 line-height2 btn btn-xs browse-btn"
              title="{{'ticketing-system.Choose File'|translate | translateKey}}">
              <span aria-hidden="true">{{'ticketing-system.Choose File'|translate | translateKey}}</span>
              <input #fileSelect type="file" id="attachFile" ng2FileSelect [uploader]="uploader"
                [disabled]="attachmentsLength==5" (change)="checkMaxAttachments()" role="file" aria-label="browse"
                style="display: none;" multiple>
            </label>
          </div>
        </div>
        <div class="pull-right mb-20 pr-42 mt-20">
          <button [disabled]=" getValidationForCreateBtn()" tabindex="0" type="submit" class="btn blue-button">
            {{'customer-service.CREATE' |translate | translateKey}}
          </button>
          <button tabindex="0" type="button" (click)="clearTicketForm()" (keyup.enter)="clearTicketForm()"
            class="btn grey-button">
            {{'customer-service.CANCEL' |translate | translateKey}}
          </button>
        </div>
      </div>
    </form>
  </div>

</section>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/work-ticket-create.component.html